import clsx from 'clsx'
import { PopupContext } from 'shared-components/contexts/PopupContext'
import styles from './PopupWrapper.module.css'
import { ThemeContext } from 'shared-components/contexts/ThemeContext'
import LocalPopup from './LocalPopup'
import { useDocumentScrollDisabled } from '../hooks/use-document-scroll-disabled'

const PopupWrapper: React.VFC = () => {
  const { popupOpened, popupClassName, popupContent, setPopupOpened } = PopupContext.useContainer()
  const { theme } = ThemeContext.useContainer()

  useDocumentScrollDisabled(popupOpened)

  return (
    <LocalPopup
      open={popupOpened}
      onBackgroundClick={() => setPopupOpened(false)}
      className={clsx(styles.wrapper, popupClassName, {
        [styles.wrapperDark]: theme === 'dark',
        [styles.wrapperLight]: theme === 'light',
      })}
    >
      {popupContent}
    </LocalPopup>
  )
}

export default PopupWrapper
